import { render } from "./TransferChatConfiguration.vue?vue&type=template&id=6bc9d3c0&scoped=true&lang=pug"
import script from "./TransferChatConfiguration.vue?vue&type=script&lang=js"
export * from "./TransferChatConfiguration.vue?vue&type=script&lang=js"

import "./TransferChatConfiguration.vue?vue&type=style&index=0&id=6bc9d3c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc9d3c0"]])

export default __exports__